import axios from '@/libs/request/axios';

const request = function(method, url, data, config) {
  const _method = (method || 'get').toLowerCase();
  let options = {
    method: (method || 'get').toLowerCase(),
    url,
  };

  // 请求方法
  options.method = _method;
  // 数据
  if (['put', 'post', 'delete', 'patch'].includes(_method)) {
    options.data = data;
  } else {
    // get等请求
    options.params = data;
  }

  // 其他配置
  options = { ...options, ...config };

  return axios(options)
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log('err', err);
      return Promise.reject(err);
    });
};

export default request;
